import styled from "styled-components";

export const ContentHomeAgent = styled.div`
  .home-meterwellness {
    display: flex;
    gap: 17px;
    margin-bottom: 24px;
  }

  .home-calmedarcoaches {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto;
    column-gap: 23px;
    row-gap: 27px;
  }

  .home-title {
    color: ${({ theme }) => theme.secondaryDarkOne};
    font-size: 40px;
    font-weight: 700;
    line-height: 32px;
    margin-top: 8px;
    margin-bottom: 57px;
  }

  .home-title_date {
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    margin-left: 5px;
  }
`;
